import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Fyrirtækjaskráning - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection containerStyle={{ padding: 30 }}>
                <ServiceHeader image="/img/thjonusta/synileiki.png" title="Fyrirtækjaskráning" />
                <p>
                    <strong>
                        <u>Fyrirtæki.</u>
                    </strong>
                </p>
                <p>
                    Grunnskráning fyrirtækja er ókeypis svo lengi sem að ekki sé önnur skráning
                    fyrir á kennitölunni.
                </p>
                <p>
                    Grunnskráning fyrirtækja felur í sér nafn fyrirtækis, heimilisfang, símanúmer,
                    opnunar- og afgreiðslutíma, heimasíðu, netfang, tengingu við samfélagsmiðla sem
                    og tegund starfsemi.
                </p>
                <h2>&nbsp;</h2>
                <p>
                    <strong>
                        <u>Ítarlegri skráning fyrirtækja</u>
                    </strong>
                </p>
                <p>
                    Þegar fyrirtæki vilja hafa ítarlegri upplýsingar skráðar en það sem boðið er upp
                    á í grunnskráningu þá bjóðum við upp á nokkrar ólíkar tegundir skráningaleiða.
                    Slíkar frekari upplýsingar eru sem dæmi:
                </p>
                <ul>
                    <li>Útibú og starfsstöðvar fyrirtækis</li>
                    <li>Deildir innan fyrirtækja</li>
                    <li>Starfsmenn og starfsheiti</li>
                </ul>
                <p>&nbsp;</p>
                <p>
                    <strong>Hér eru þrjár leiðir í boði.</strong>
                </p>
                <table className="table">
                    <tbody>
                        <tr>
                            <td>
                                <p>
                                    <strong>Ítarlegri skráning</strong>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <strong>Innifalið</strong>
                                </p>
                            </td>
                            <td width="15%">
                                <p>
                                    <strong>
                                        Verð á ári *<br />
                                    </strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Minni skráning</p>
                            </td>
                            <td>
                                <p>
                                    1-5 skráningar fyrir aukasímanúmer, útibú, deildir og starfsmenn
                                    <br />
                                    <br />
                                    <br />
                                </p>
                            </td>
                            <td>
                                <p>9.900 kr.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Meðal skráning</p>
                            </td>
                            <td>
                                <p>
                                    6-14 skráningar fyrir aukasímanúmer, útibú, deildir og
                                    starfsmenn
                                    <br />
                                    <br />
                                </p>
                            </td>
                            <td>
                                <p>21.900 kr.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Stærri skráning</p>
                                <ul>
                                    <li>Inniheldur ótakmarkaðar viðbótarskráningar</li>
                                </ul>
                            </td>
                            <td>
                                <p>
                                    Skráningar fyrir aukasímanúmer, útibú, deildir og starfsmenn
                                    <br />
                                    <br />
                                    <br />
                                </p>
                            </td>
                            <td>
                                <p>43.900 kr.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <small>
                        &nbsp;* Öll verð eru án vsk
                        <br />
                    </small>
                </p>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
